// extracted by mini-css-extract-plugin
export default {"container":"AboutSlide_container__Hy0Xh","easy":"AboutSlide_easy__aKm3y","image":"AboutSlide_image__9h6s5"};